import { render, staticRenderFns } from "./InitPassword.vue?vue&type=template&id=4db7b38f&scoped=true&"
import script from "./InitPassword.vue?vue&type=script&lang=js&"
export * from "./InitPassword.vue?vue&type=script&lang=js&"
import style0 from "./InitPassword.vue?vue&type=style&index=0&id=4db7b38f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7b38f",
  null
  
)

component.options.__file = "InitPassword.vue"
export default component.exports